import { crestHttp, http } from './client.js';

export interface LoginMethodsConfig {
  passwordLoginEnabled: boolean;
  dingtalkLoginEnabled: true;
}

export async function fetchPublicLoginMethods(): Promise<LoginMethodsConfig> {
  const { data } = await crestHttp.get<LoginMethodsConfig>('/auth/login-methods');
  return data;
}

export async function fetchAdminLoginMethods(): Promise<LoginMethodsConfig> {
  const { data } = await http.get<LoginMethodsConfig>('/admin/system-config/login-methods');
  return data;
}

export async function saveAdminLoginMethods(
  patch: Pick<LoginMethodsConfig, 'passwordLoginEnabled'>,
): Promise<LoginMethodsConfig> {
  const { data } = await http.put<LoginMethodsConfig>('/admin/system-config/login-methods', patch);
  return data;
}
